import React, { useEffect, useState, useRef, useContext } from 'react';
import { useParams } from 'react-router-dom';
import styles from './ApplicationsPage.module.scss';
import { useFetchAcademicYears } from '../../../Hooks/Settings';
import ApplicantDetails from '../../Molecules/detailsBox/applicantDetailsBox';
import TableTopHeader from '../../Molecules/TableTopHeader/ApplicationsTableTopHeader';
import ApplicantsTable from '../../Molecules/Applications/ApplicantsTable';
import { PageTitleContext } from '../../HOC/GeneralBody/GeneralBody';
import {
  useFetchHappinessMeter,
  useExportTableHappinessMeter,
  useFetchSingleHappinessMeter,
} from '../../../Hooks/Applications';

const ApplicationsPage = () => {
  const [Page, setPage] = useState(1);
  const [PageSize, setPageSize] = useState(10);
  const [selected, setSelected] = useState('happinessMeter');
  const [applicantsNumber, setApplicantsNumber] = useState(0);
  const [applicationId, setApplicationId] = useState('');
  const [moveRight, setMoveRight] = useState(false);
  const [search, setSearch] = useState();
  const [order, setOrder] = useState(['', 'asc']);
  const [mode, setMode] = useState('happinessMeter');
  const [details, setDetails] = useState('');

  const applicantsTableHeader = [
    {
      name: 'التقييم',
      originalName: 'rating',

      sort: false,
    },
    {
      name: 'التاريخ',
      originalName: 'date',
      sort: false,
    },
  ];

  const {
    data: happinessMeter,
    refetch: refetchHappinessMeter,
    isLoading: isLoading,
  } = useFetchHappinessMeter({
    pageSize: PageSize,
    pageNumber: Page,
    search: search,
    OrderBy: order[0],
    OrderDir: order[1],
  });

  const {
    data: applicantsPrint,
    refetch: refetchHappinessMeterPrint,
    isLoading: isLoading00,
  } = useFetchHappinessMeter({
    pageSize: 10000,
    pageNumber: 1,
    search: search,
    OrderBy: order[0],
    OrderDir: order[1],
  });

  const { data: HappinessMeterbyId, refetch: refetchSingleHappinessMeter } =
    useFetchSingleHappinessMeter(details);
  //---------------------------------exportTables All
  const exportHappinessMeterTable = useExportTableHappinessMeter();
  const handleExportTable = async () => {
    try {
      var data = await exportHappinessMeterTable.mutateAsync();

      if (data.data instanceof Blob) {
        const blob = new Blob([data.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'HappinessmeterTable';
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        console.error('Unexpected data type. Expected string.');
      }
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };
  //-------------------------------------
  useEffect(() => {}, [details]);

  useEffect(() => {
    refetchHappinessMeter();
  }, [Page, PageSize, search, order]);

  useEffect(() => {
    if (happinessMeter && !applicantsNumber) {
      setApplicantsNumber(happinessMeter && happinessMeter.data.totalCount);
    }
  }, [happinessMeter]);

  useEffect(() => {
    setSearch('');
    setPage(1);
    setPageSize(10);
    setOrder(['', 'asc']);
  }, [selected]);
  console.log('Cdsncjksd', happinessMeter?.data);
  return (
    <>
      {!details ? (
        <div className={styles['container']}>
          <div className={styles['search-container']}>
            <div className={styles['table-container']}>
              <TableTopHeader
                rowsCount={happinessMeter}
                mode={mode}
                handleExport={handleExportTable}
                search={search}
                setSearch={setSearch}
                data={applicantsPrint?.data}
                refetch={refetchHappinessMeterPrint}
                tableHeader={applicantsTableHeader}
                title="Happines Meter Table"
              />
              <ApplicantsTable
                data={happinessMeter?.data}
                tableHeader={applicantsTableHeader}
                mode={mode}
                page={Page}
                setPage={setPage}
                pageSize={PageSize}
                setPageSize={setPageSize}
                isApplicantsLoading={isLoading}
                setDetails={setDetails}
                setApplicationId={setApplicationId}
                details={details}
                order={order}
                setOrder={setOrder}
                refetch={refetchHappinessMeter}
                setMoveRight={setMoveRight}
                isLoading={isLoading}
              />
            </div>
          </div>
        </div>
      ) : (
        <>
          <ApplicantDetails
            data={HappinessMeterbyId && HappinessMeterbyId.data}
            setDetails={setDetails}
            details={details}
            applicantId={details}
            applicationId={applicationId}
            refetchSingleApplicant={refetchSingleHappinessMeter}
            setMoveRight={setMoveRight}
            moveRight={moveRight}
          />
        </>
      )}
    </>
  );
};

export default ApplicationsPage;
